var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-container"},_vm._l((_vm.messages),function(message,index){return _c('b-alert',{key:index,attrs:{"show":"","fade":"","dismissible":"","variant":message.type}},[_c('span',[_vm._v(_vm._s(message.text))])])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59ac3012","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/node_modules/vue-loader/lib/selector.js?type=template&index=0!/node_modules/string-replace-loader??ref--5!/src/components/Message.vue
// module id = null
// module chunks = 